import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { urlAppendParam } from 'utils/navigation/tabsHeader.utils';
import './tabsHeader.scss';

export default function TabsHeader({
  options,
  param = 'tab',
  variant = 'secondary',
  borderRadius = '8px',
}) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const rawParam = searchParams.get(param);

  const normalizedOptions = options?.map((item) => ({
    option: item.option,
    normalized: item.option?.toLowerCase(),
  }));
  const activeOption =
    normalizedOptions?.find((item) => item.normalized === rawParam?.toLowerCase()) ||
    normalizedOptions?.[0];
  const selectedTab = activeOption?.normalized || '';

  useEffect(() => {
    if (!activeOption || !rawParam) return;
    if (rawParam === activeOption.option) return;
    navigate(urlAppendParam(param, activeOption.option), { replace: true });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOption?.option, navigate, param, rawParam]);

  return (
    <nav
      aria-label={param === 'tab' ? 'Page sections' : `${param} navigation`}
      className="tabs-header d-flex flex-column flex-lg-row gap-1 p-1 w-100"
      data-variant={variant}
      style={{ borderRadius }}
    >
      {options?.map((item) => (
        <Link
          className="tabs-header-link focus-ring-theme d-flex align-items-center justify-content-center text-center text-decoration-none"
          key={item.option}
          to={urlAppendParam(param, item.option)}
          aria-current={selectedTab === item.option.toLowerCase() ? 'page' : undefined}
        >
          {item.label ?? item.option}
        </Link>
      ))}
    </nav>
  );
}
